const modules = import.meta.glob<{ default: string }>('./dobrejovice-*.jpg', { eager: true });

export const dobrejoviceImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/dobrejovice-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/dobrejovice-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);
